module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie PageFooter wraps the footer of the Page.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;PageFooter&gt;\n    &lt;div&gt;Footer content...&lt;/div&gt;\n&lt;/PageFooter&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/PageFooter/README.md
// module id = 373
// module chunks = 0